var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"fas icon-bg-shine",attrs:{"icon":_vm.icon === 'motionelements' ? _vm.faMeMotionelements : ['fas',("me-" + _vm.icon)],"size":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }